/** Route path constants (no React imports — safe to import from hooks without cycles). */
export const PATHS = {
  HOME: '/',
  LOGIN: '/login',
  LOGIN_DENIED: '/login-denied',
  TEST_COMPONENTS: '/test',
  ORDERS: '/orders',
  ORDERS_BY_STATUS: '/orders/:status',
  MENU: '/menu',
  SPECIAL_MENU_TEST: '/special',
  PERFORMANCE: '/performance',
  PERFORMANCE_BY_ID: '/performance/:id',
  ACCOUNT: '/account',
  ACCOUNT_ORDER_PREFERENCES: '/account/order-preferences',
  BILLING: '/billing',
  REGISTRATION: '/registration',
  EMAIL_VERIFICATION: '/registration/verify-email',
  OFFERS: '/offers',
  OFFERS_BY_ID: '/offers/:id',
  OFFERS_CREATE: '/offers/item-discount/create',
  OFFERS_CART_DISCOUNT_CREATE: '/offers/cart-discount/create',
  OFFERS_BUYX_GETY_CREATE: '/offers/buyx-gety/create',
  MARKETING_TOOLS: '/marketing/tools',
  MARKETING_CAMPAIGNS: '/marketing/campaigns',
  BRANCH_BUSINESS_HOURS: '/branch/business-hours'
}
